import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '@/i18n';

interface SloganBannerSectionProps {
  variant?: 'academic' | 'music';
}

const SloganBannerSection: React.FC<SloganBannerSectionProps> = ({ variant = 'academic' }) => {
  const { locale } = useI18n();
  const isZh = locale === 'zh-CN';
  return (
    <section className="bg-white py-8 md:py-10">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true, amount: 0.4 }}
        className="w-full border-y border-primary-100 bg-gradient-to-r from-primary-50 via-white to-primary-50 px-6 py-10 shadow-[0_18px_44px_rgb(var(--brand-primary)/0.08)] md:px-10 md:py-12"
      >
        <div className="mx-auto max-w-2xl text-center md:max-w-5xl">
          <h2 className={`text-3xl font-bold tracking-tight md:text-5xl ${variant === 'music' ? 'text-gray-900' : 'text-primary'}`}>
            {variant === 'music' ? 'Still looking for the right music tutor?' : isZh ? '还不是最合适的导师？' : 'Not the perfect match?'}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-gray-600 md:text-lg">
            {variant === 'music'
              ? 'Tell us what you want to learn and we’ll help you find the right fit.'
              : isZh ? '我们会免费协助你重新寻找另一位导师。' : 'We’ll help you find another tutor at no additional charge.'}
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default SloganBannerSection;
